import * as THREE from 'three';

// Which way a label has to be turned to be readable. Kept out of three.js's scene graph, in
// the way of the other Utils modules, so the maths can be tested under jsdom — the 3D chain
// itself cannot be imported there.
//
// The letters are cut flat, so a label is only readable while its face — its own +Z, the
// direction it was extruded along — is turned back towards the camera. That is one
// orientation, shared by every object oriented to the screen: give the label the camera's
// own quaternion and its +Z points the way the camera's +Z does, square to the frame and
// upright. Aiming it at the camera's position instead would leave every label at a
// different angle, and pitch is not optional — a camera looking down would read the letters
// edge on.

/**
 * The quaternion that turns a label to face the camera.
 *
 * The label's quaternion is relative to its parent, and the parent may be turned — the
 * planets sit all the way round the sun, each at its own angle — so the parent's own turn
 * is taken back out first. Handing back the camera's quaternion directly would be right only
 * while the parent happened to be unturned.
 *
 * @param {THREE.Quaternion} parentWorldQuaternion - the label's parent, in world terms.
 * @param {THREE.Quaternion} cameraWorldQuaternion - the camera's own orientation.
 * @param {THREE.Quaternion} [target] - written into, so a per-frame caller need not
 *   allocate. A new quaternion is made when it is left out.
 * @returns {THREE.Quaternion} the label's own quaternion. Neither argument is changed.
 */
export function facingQuaternion(parentWorldQuaternion, cameraWorldQuaternion, target = new THREE.Quaternion()) {
    return target.copy(parentWorldQuaternion).invert().multiply(cameraWorldQuaternion);
}
